module.exports = __webpack_public_path__ + "img/4.26c5a5a7.png";